import React from "react";
import Spinner from "./../Spinner/Spinner";

const SuspenseFallback = () => (
  <div>
    <Spinner />
  </div>
);
export default SuspenseFallback;
